import { formatCurrency, formatDate } from "../utils/format-utils";

export default class SessionInvoicePayment {
  sessionInvoiceId?: number;
  sessionId?: number | null;
  invoiceDate?: Date | null;
  billedAmount?: number | null;
  invoiceNumber?: string | null;
  paymentDate?: Date | null;
  postedAt?: Date | null;
  payer?: string | null;
  checkNumber?: string | null;
  paidAmount: number;
  adjustmentAmount?: number | null;
  adjustmentType?: string | null;

  public constructor(
    params: SessionInvoicePayment = {} as SessionInvoicePayment
  ) {
    let {
      sessionInvoiceId = 0,
      sessionId = null,
      invoiceDate = null,
      billedAmount = 0,
      invoiceNumber = "",
      paymentDate = null,
      postedAt = null,
      payer = null,
      checkNumber = "",
      paidAmount = 0,
      adjustmentAmount = 0,
      adjustmentType = "",
    } = params;
    this.sessionInvoiceId = sessionInvoiceId;
    this.sessionId = sessionId;
    this.invoiceDate = invoiceDate;
    this.billedAmount = billedAmount;
    this.invoiceNumber = invoiceNumber;
    this.paymentDate = paymentDate;
    this.postedAt = postedAt;
    this.payer = payer;
    this.checkNumber = checkNumber;
    this.paidAmount = paidAmount;
    this.adjustmentAmount = adjustmentAmount;
    this.adjustmentType = adjustmentType;
  }

  get uniqueId() {
    if (this.checkNumber) return this.sessionInvoiceId + "-" + this.checkNumber;
    else return this.sessionInvoiceId;
  }

  get formattedInvoiceDate() {
    return formatDate(this.invoiceDate);
  }

  get formattedBilledAmount() {
    return formatCurrency(this.billedAmount);
  }

  get formattedInvoiceNumber() {
    return this.invoiceNumber || "N/A";
  }

  get formattedPaymentDate() {
    return Boolean(this.paymentDate) ? formatDate(this.paymentDate) : "";
  }

  get formattedPaidAmount() {
    return Boolean(this.paidAmount) ? formatCurrency(this.paidAmount) : "";
  }

  get formattedAdjustmentAmount() {
    return Boolean(this.adjustmentAmount)
      ? formatCurrency(this.adjustmentAmount)
      : "";
  }

  get formattedAdjustmentType() {
    return this.adjustmentType || "";
  }

  get status() {
    if (Boolean(this.postedAt)) return "Posted";
    else if (Boolean(this.paymentDate)) return "Not Posted";
    else if (Boolean(this.invoiceDate)) return "Billed";
    return "Pending";
  }

  get formattedPostedAt() {
    return this.postedAt ? formatDate(this.postedAt) : "";
  }
}
